import { iamportCertifications, iamportFindCertifications } from "../api/auth";

// 본인인증 재시도 함수
async function attemptCertification(find?: boolean): Promise<{
  username: string;
  phoneNumber: string;
  birth: string[];
  gender: "MALE" | "FEMALE";
  existed: boolean;
  exited: boolean;
  userId?: number;
  nickname?: string;
  textId?: string;
  isAlreadyDoReferral: boolean;
}> {
  return new Promise((resolve, reject) => {
    if (!window.IMP) {
      return reject(new Error("아이엠포트 초기화 실패"));
    }

    window.IMP.certification(
      {
        merchant_uid: "merchant_" + new Date().getTime(),
        popup: false,
      },
      async (resp) => {
        if (resp.success) {
          try {
            const certFn = find
              ? iamportFindCertifications
              : iamportCertifications;
            const certResp = await certFn({
              impUid: resp.imp_uid,
              merchantUid: resp.merchant_uid,
            });

            const [birthYear, birthMonth, birthDate] =
              certResp.data.birthday.split("-");

            resolve({
              username: certResp.data.name,
              phoneNumber: certResp.data.phone,
              birth: [birthYear, birthMonth, birthDate],
              gender: certResp.data.gender === "male" ? "MALE" : "FEMALE",
              existed: certResp.isAlreadyExistUser,
              exited: certResp.isAlreadyExitUser,
              userId: certResp.userId,
              nickname: certResp.nickname,
              textId: certResp.textId,
              isAlreadyDoReferral: certResp.isAlreadyDoReferral,
            });
          } catch (e: any) {
            const msg = typeof e === "string" ? e : e.message;
            reject(new Error(msg));
          }
        } else {
          reject(new Error(resp.error_msg || "본인인증 실패"));
        }
      }
    );
  });
}

export async function certification(find?: boolean) {
  // 안드로이드 웹뷰에서 자판이 올라와 있는 상태로 페이지 이동 시 
  // 포커스 이슈로 인해 한글 입력이 안 되는 현상을 방지하기 위해 
  // 더미 input을 사용한 IME 초기화와 부모 페이지 포커스 억제 로직을 추가합니다.
  if (typeof document !== "undefined") {
    const dummy = document.createElement("input");
    dummy.style.position = "absolute";
    dummy.style.top = "-9999px";
    dummy.style.opacity = "0";
    document.body.appendChild(dummy);
    dummy.focus();
    await new Promise((resolve) => setTimeout(resolve, 50));
    dummy.blur();
    document.body.removeChild(dummy);
  }

  // 인증 진행 중 부모 페이지가 포커스를 가져가지 않도록 하는 리스너
  const focusHandler = () => {
    if (
      document.activeElement &&
      document.activeElement !== document.body &&
      !document.activeElement.tagName.includes("IFRAME")
    ) {
      (document.activeElement as HTMLElement).blur();
    }
  };
  window.addEventListener("focus", focusHandler, true);

  window.focus();
  await new Promise((resolve) => setTimeout(resolve, 1500));

  const maxRetries = 3;
  let lastError: Error = new Error("알 수 없는 오류");

  try {
    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      try {
        console.log(`본인인증 시도 ${attempt}/${maxRetries}`);
        const result = await attemptCertification(find);
        window.removeEventListener("focus", focusHandler, true);
        return result;
      } catch (error: any) {
        lastError = error;
        const msg = (typeof error === "string"
          ? error
          : error.message) as string;

        if (msg.indexOf("사용자") > -1) {
          // 사용자가 취소하면 바로 종료
          break;
        }
        console.warn(`본인인증 ${attempt}/${maxRetries} 실패:`, error.message);

        // 마지막 시도가 아니면 잠시 대기
        if (attempt < maxRetries) {
          console.log(`${attempt * 1000}ms 후 재시도...`);
          await new Promise((resolve) => setTimeout(resolve, attempt * 1000));
        }
      }
    }
  } finally {
    window.removeEventListener("focus", focusHandler, true);
  }

  console.error("본인인증 최종 실패:", lastError.message);
  throw lastError;
}
